(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["musky-size-picker"] && !Shopify.designMode) return;
  try {
    
  function muskyBindSizePicker(picker) {
    if (picker.dataset.muskyBound === 'true') return;
    picker.dataset.muskyBound = 'true';

    const tabs = Array.from(picker.querySelectorAll('[role="tab"]'));
    const panels = Array.from(picker.querySelectorAll('[role="tabpanel"]'));

    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        if (panels[i]) panels[i].hidden = !selected;
      });
      if (focus && tabs[index]) tabs[index].focus();
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i, false));
      tab.addEventListener('keydown', (event) => {
        const last = tabs.length - 1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          select(i === last ? 0 : i + 1, true);
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          select(i === 0 ? last : i - 1, true);
        } else if (event.key === 'Home') {
          event.preventDefault();
          select(0, true);
        } else if (event.key === 'End') {
          event.preventDefault();
          select(last, true);
        }
      });
    });
  }

  function muskyBindAllSizePickers(root) {
    (root || document).querySelectorAll('[data-musky-size-picker]').forEach(muskyBindSizePicker);
  }

  muskyBindAllSizePickers();
  // El editor de tema vuelve a renderizar la sección: hay que re-enlazar.
  document.addEventListener('shopify:section:load', (event) => muskyBindAllSizePickers(event.target));

  } catch(e) { console.error(e); }
})();
})();
